import { render } from "./Submissions.vue?vue&type=template&id=a19cd5f2&scoped=true"
import script from "./Submissions.vue?vue&type=script&lang=js"
export * from "./Submissions.vue?vue&type=script&lang=js"

import "./Submissions.vue?vue&type=style&index=0&id=a19cd5f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a19cd5f2"]])

export default __exports__